// Render Prop

import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import SimpleField from "../../forms/SimpleField";
import DatePickerField from "../../forms/DatePickerField";


import "react-datepicker/dist/react-datepicker.css";

import Account from "../../../store/wrappers/Account";
import { AccountApi } from "../../../util/api/AccountApi";


import BackButton from "../../widgets/BackButton";

import SelectSearchField from '../../forms/SelectSearchField';
import { withRouter } from 'react-router';

import { Alert } from "../../../store/Alert";




class AccountForm extends Component {
    static displayName = AccountForm.name;

    constructor(props) {
        super(props);

        //By default, assume account object with default values
        let account = new Account({});
        let displayMode = "new";
        if (this.props.match.params.id) {
            account = props.store.accounts.getById(this.props.match.params.id);
            displayMode = "edit"
        }

        this.state = {
            account: account,
            mode: displayMode,
            selectedEmployerId: account.employerId,
            selectedSupervisorId: account.supervisorId,
            supervisorKey: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),
            secondarySupervisorsKey: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER) //This force-refreshes the secondary supervisor component 
        };

        if (displayMode == "new") {
            props.store.updateBanner("Add New");
        }
        else {
            let account = props.store.accounts.getById(this.props.match.params.id);

            account = account.include(["student", "employer"]);

            const name = `${account.student.name} - ${account.employer.name}`;

            props.store.updateBanner("Update Account", name);
        }

        this.onEmployerIdChange = this.onEmployerIdChange.bind(this);
        this.onSupervisorIdChange = this.onSupervisorIdChange.bind(this);
        //this.onSecondSupervisorChange = this.onSecondSupervisorChange.bind(this);
        this.redirectToAccountStatus = this.redirectToAccountStatus.bind(this);

        this.deleteAccount = this.deleteAccount.bind(this);
    }

    redirectToAccountStatus(event) {
        event.preventDefault()
        this.props.history.push("/staff/AccountStatus/" + this.state.account.id);
    }

    async deleteAccount(e) {
        if(window.confirm( "Are you sure you'd like to remove this account from SWS?" )) {
            const accountId = e.target.value;
            console.log(e)

            await AccountApi.delete(accountId);
            
            await this.props.store.getFromApi(["accounts"])
            
            this.props.history.goBack();

            let successAlert = new Alert("Successfully deleted account");

        }
    }


    setInitialValues() {

        return {
            id: this.state.account.id,
            employerId: this.state.account.employerId || "0",
            studentId: this.state.account.studentId || "0",
            startDate: this.state.account.startDate ? new Date(this.state.account.startDate) : null,
            endDate: this.state.account.endDate ? new Date(this.state.account.endDate) : null,
            payRate: this.state.account.payRate || "15.00",
            supervisorId: this.state.account.supervisorId || "0",
            secondarySupervisorIds: this.state.account.secondarySupervisorIds || [],
            fopal : this.state.account.fopal || ""
        }
    }

    async handleSubmission(values, setSubmitting, resetForm) {
        this.setState({ isSubmitting: true });
        console.log(values)

        let account = new Account(values, this.props.store, true);


        account = await account.save(this.props.store);

        console.log(account)

        //If there aren't errors and we're adding accounts
        if (this.state.mode == "new"  && account.errors.length == 0) {
            console.log("added account")
            resetForm()
            this.setState({ setSubmitting: false });
        }
        else if (account.errors.length == 0) {
            console.log("updated account")
            this.setState({
                account: account,
                isSubmitting: false,
            });
        }
    }

    validate(values) {
        const errors = {};

        if (values.employerId == "0") {
            errors.employerId = "Must select an employer"
        }

        if (values.supervisorId == "0") {
            errors.supervisorId = "Must select a supervisor"
        }

        if (values.studentId == "0") {
            errors.studentId = "Must select a student"
        }

        return errors;
    }

    render() {
        return (
            <div>
                {this.introText()}
                {this.form()}
            </div>
        )
    }

    introText() {
        if (this.state.mode == "new") {
            return (
                <React.Fragment>
                    <h1 className="h3">New Account</h1>
                </React.Fragment>
            )
        }
        return (undefined);
    }


    onEmployerIdChange(value) {
        this.setState({
            selectedEmployerId: value,
            supervisorKey: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER),
            secondarySupervisorsKey: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER) //This force-refreshes the secondary supervisor component 
        });
    }

    onSupervisorIdChange(update, form) {
        this.setState({
            selectedSupervisorId: update,
            secondarySupervisorsKey: Math.floor(Math.random() * Number.MAX_SAFE_INTEGER )
        });
        console.log(form)
        form.setFieldValue("secondarySupervisorIds", [])
    }

    form() {
        //We should only retrieve students with award amounts assigned--newly-migrated students must be given an award amount.
        const students = this.props.store.students.collection
            .filter(student => student.awardAmount > 0)
            .sort(this.props.store.students.sortByLastName)
        
        let employers = this.props.store.employers.collection;

        employers.sort((employerA, employerB) => {
            if(employerA.name > employerB.name) {
                return 1;
            }
            else if(employerB.name > employerA.name) {
                return -1;
            }
            return 0;
        });

        let supervisors = this.props.store.supervisors.collection;

        let supervisorFormDisabled = true;
        let secondarySupervisorFormDisabled = true;


        if (this.state.selectedEmployerId) {
            supervisorFormDisabled = false;
            supervisors = supervisors.filter(supervisor => supervisor.employerId == this.state.selectedEmployerId);
        }

        let secondarySupervisors = [];
        if (this.state.selectedSupervisorId) {
            secondarySupervisorFormDisabled = false;
            secondarySupervisors = supervisors.filter(supervisor => supervisor.id != this.state.selectedSupervisorId)
        }


        const formatSelectData = (x) => {
            return {
                label: x.name,
                value: x.id
            }
        }

        return (
            (this.state.mode == "new" || this.state.account ? (
                <React.Fragment>
                <Formik
                    enableReinitialize={true}
                    initialValues={this.setInitialValues()}
                    validate={values => this.validate(values)}
                    onSubmit={(values, { setSubmitting, resetForm }) => this.handleSubmission(values, setSubmitting, resetForm)}
                >
                    {({ isSubmitting }) => (


                        <Form>
                            <Field name="id" className="form-control" type="hidden" />

                            <div className="row">
                                <div className="col-12 col-md-6 col-lg-5">

                                    {/*SelectField items={employers} name="employerId" label="Employer" />
                                                                        <SelectField items={supervisors} name="supervisorId" label="Supervisor" />

                                    <SelectField items={students} name="studentId" label="Student" />

                                    */}
                                    <Field component={SelectSearchField} name="studentId" label="Student" options={students.map(student => formatSelectData(student))} />
                                    <Field component={SelectSearchField} name="employerId" label="Employer" onChange={this.onEmployerIdChange} options={employers.map(employer => formatSelectData(employer))} />
                                    <Field component={SelectSearchField} key={this.state.supervisorKey} name="supervisorId" label="Primary Supervisor" onChange={this.onSupervisorIdChange} options={supervisors.map(supervisor => formatSelectData(supervisor))} isDisabled={supervisorFormDisabled} />
                                    <Field component={SelectSearchField} key={this.state.secondarySupervisorsKey} name="secondarySupervisorIds" onChange={(e) => console.log(e)} label="Additional Supervisors (optional)" isMulti={true} options={secondarySupervisors.map(supervisor => formatSelectData(supervisor))} isDisabled={secondarySupervisorFormDisabled} />

                                </div>

                                <div className="col-12 col-md-6 col-lg-5">
                                    <DatePickerField name="startDate" label="Start Date" />
                                    <DatePickerField name="endDate" label="End Date" />
                                    <SimpleField name="payRate" label="Pay Rate" type="number" step="0.01" />
                                    <SimpleField name="fopal" label="FOPAL" type="text" />
                                </div>
                            </div>

                        
                            <div className="staffFormSubmitButtons">
                                {this.state.mode !== "new" &&
                                    <React.Fragment>
                                        <BackButton className="btn btn-secondary mt-2 mr-2 ml-0" innerText="Cancel" />
                                        <button value={this.props.match.params.id} type="button" onClick={this.deleteAccount} className="btn btn-secondary mr-2 mt-2">Delete Account</button>
                                    </React.Fragment>
                                }
                                {this.state.mode !== "new" &&
                                    (<button type="button" onClick={this.redirectToAccountStatus} className="btn btn-secondary mt-2 mr-2">Update Account Status</button>)
                                }
                                <button className="btn btn-primary mt-2 mr-2" type="submit" disabled={isSubmitting}>
                                    Submit
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
                </React.Fragment>
            ) :
                (
                    <div>
                        <h3>Could not find account.</h3>
                    </div>
                )
            )
        );
    }
}

AccountForm = withRouter(AccountForm)

export { AccountForm }